const SET = 'aiDiagnosisTestData.SET';

const defaultState = {
    grade : '',
    year : '',
    yearLabel : '출생년도',
    month : '',
    monthLabel : '월',
    gender : '',
};

const set = data => ( { type : SET, data : data } );

const aiDiagnosisTestData = ( state=defaultState, action ) => {

  switch ( action.type ) {
    case SET :
      return { ...state, ...action.data };
    default :
      return state;
  }

};

export default aiDiagnosisTestData;
export { set };
